<template>
  <div id="app">
    <Header />
    <h1><span>{{ tweet }}</span></h1>
    <section class="error" v-if="errored">
      <p>We're sorry, we're currently holding a series of indicative votes about whether to load the data or not... please hit refresh to have another attempt...</p>
    </section>
    <!-- Select a word list -->
    <section class="brexit" v-else v-show="!tweet_id">
      
      <div class="summary" v-if="nextWords && !tweet_id">Found {{ nextWords.length | thousands }} next words from {{ results.total | thousands }} tweets, choose your next word...</div>
      <div class="summary" v-if="loading">"Loading tweets that begin: 'Brexit is like'"</div>
      
      <ul class="word-list" v-else>
        <li 
          class="word-list__list-item"
          v-for="word in nextWords" 
          :key="word.key"
          @click="updateSelectedWords(word.key);">
          <span class="word">{{ word.key }}</span>
          <span class="badge">{{ word.doc_count }}</span>
        </li>
      </ul>
    </section>
    <section class="embed">
      <Tweet 
        class="tweet-embed" 
        v-if="tweet_id"
        :id="tweet_id"
        error-message="This tweet could not be loaded"
        :widget-class="`brexit-tweet`"><div class="spinner"></div></Tweet>
    </section>
    <section v-if="finished">
      <button @click="hardbrexit()">Play again!</button>
    </section>
    <section class="share">
      <vue-goodshare-twitter
        page_url="https://cogapp.github.io/brexit"
        title_social="Twitter"
        has_counter
        has_icon>
      </vue-goodshare-twitter>
      <vue-goodshare-email has_icon title_social="Email"/>
    </section>
    <footer>
      <p class="credits">Background image by Gavin Mallory ❤️ All rights reserved. Made with 🔥 and 😡 in Remainia, err, Brighton.</p>
    </footer>
  </div>
</template>

<script>
import Header from './components/Header.vue'
import axios from 'axios'
import { Tweet } from 'vue-tweet-embed'
import VueGoodshareTwitter from "vue-goodshare/src/providers/Twitter.vue";
import VueGoodshareEmail from "vue-goodshare/src/providers/Email.vue";

export default {
  name: 'app',
  components: {
    Header,
    Tweet,
    VueGoodshareTwitter,
    VueGoodshareEmail,
  },
  computed: {
    date_min() {
      return '';
    },
    date_max() {
      return '';
    },
    tweet() {
      if (this.selectedWords.length) {
        const phrase = this.selectedWords.join(" ");
        let tweet = `Brexit is like ${phrase}`;
        return this.finished ? tweet : `${tweet}...`;
      }
      return 'Brexit is like...';
    },
    query() {
      if (this.selectedWords.length) {
        return this.selectedWords.join(' ');
      }
      return "";
    },
    nextWords() {
      if (this.results) {
        return this.results.results.by_count.buckets;
      }
    }
  },
  data () {
    return {
      selectedWords: [],
      loading: true,
      errored: false,
      results: null,
      tweet_id: null,
      finished: false,
    }
  },
  mounted () {
    this.fetchWords();
  },
  watch: {
    query() {
      this.fetchWords();
    }
  },
  filters: {
    thousands: function (value) {
      if (!value) return '0';
      return value.toLocaleString('en-GB');
    }
  },
  methods: {
    hardbrexit() {
      this.$ga.event('UI', 'Played again') 
      this.results = null;
      this.tweet_id = null;
      this.selectedWords = [];
      this.finished = false;
      this.fetchWords();
    },
    fetchWords() {
      axios
      .get(`https://y5qmqhk8ak.execute-api.eu-west-2.amazonaws.com/dev/words?words=${this.query}`)
      .then(response => {
        this.results = response.data; 
        if (this.results.results.by_count.buckets.length === 1) {
          const buckets = this.results.results.by_count.buckets;
          const word = buckets[0].key;
          this.selectedWords.push(word);
          this.tweet_id = this.results.tweet._id;
          this.finished = true;
        }
      })
      .catch(error => {
        this.errored = true
        // eslint-disable-next-line
        console.log(error)
      })
      .finally(() => this.loading = false)
    },
    updateSelectedWords(word) {
      this.$ga.event('UI', 'Word chosen', word)
      this.selectedWords.push(word);
    }
  }
}
</script>

<style>

#app {
  min-height: 100%;
  background-size: cover;
  background-image: url('./assets/blurry_brexit.jpg');
  background-attachment: fixed;
  display: flex;
  flex-direction: column;
}

a {
  color: white;
}

a:visited {
  color: white;
}

.container {
  max-width: 1024px;
  margin: 0 auto;
}

.error {
  background: rgba(0, 0, 0, 0.85);
  color: white;
}

section {
  display: flex;
  align-items: center;
  flex-direction: column;
  flex: 1 0 auto;
}

footer p {
  margin-bottom: 0;
  padding-bottom: 0;
}

h1 {
  margin: 0;
  font-size: 24px;
  background: rgba(0, 0, 0, 0.85);
  color: white;
  padding: 24px 12px;
}

@media (min-width: 800px) {
  h1 {
    font-size: 48px;
  }
}

.word-list { 
  padding: 0;
  margin-top: 60px;
  list-style: none;
}

.embed {
  display: block;
}

.tweet {
  padding-right: 0.5rem;
}

.twitter-tweet {
  margin: 20px auto;
}

button {
  display: inline-block;
  border: none;
  padding: 1rem 2rem;
  margin-bottom: 2rem;
  text-decoration: none;
  background: #0069ed;
  color: #ffffff;
  font-family: sans-serif;
  font-size: 1rem;
  line-height: 1;
  cursor: pointer;
  text-align: center;
  transition: background 250ms ease-in-out, transform 150ms ease;
  -webkit-appearance: none;
  -moz-appearance: none;
}

button:hover,
button:focus {
  background: #0053ba;
}

button:focus {
  outline: 1px solid #fff;
  outline-offset: -4px;
}

button:active {
  transform: scale(0.99);
}

.summary {
  background: rgba(0, 0, 0, 0.85);
  font-weight: 700;
  padding: 12px 8px 30px 8px;
  color: white;
}

.word-list__list-item {
  display: inline-flex;
  flex-direction: column;
  margin: 0 10px 10px 0;
  color: white;
  background: blue;
  list-style-type: none;
  cursor: pointer;
}

.word-list__list-item:hover {
  background: red;
}

@media (min-width: 800px) {
  .word-list__list-item {
    margin: 0 5px 5px 0;
  }
}

.word {
  padding: 0 10px 0 10px;
  word-break: break-word;
  font-size: 20px;
  font-weight: 700;
}

@media (min-width: 800px) {
  .word {
    font-size: 36px;
  }
}

.badge {
  font-size: 12px;
  font-style: italic;
  color: white;
  background: rgba(0, 0, 0, 0.85);;
  font-weight: bold;
  padding: 4px 0;
}

.brexit-tweet {
  max-width: 100%;
  flex: 1 0 auto;
}

.share {
  flex: 0 0 auto;
}

.brexit {
  display: block;
  flex: 1 0 auto;
}

.credits {
  background: white;
  font-size: 12px;
  font-weight: bold;
  padding: 4px;
}
</style>
